/**
 * Admin Auto-Assignment Helper
 * Automatically assigns admin role to designated phone numbers
 */

const ADMIN_PHONE_NUMBERS = [
  '+919620211079',
  '+919611638031'
];

/**
 * Check if a phone number should be assigned admin role
 */
export function isAdminPhoneNumber(phoneNumber: string): boolean {
  // Normalize: remove spaces, dashes, etc.
  const normalized = phoneNumber.replace(/[\s\-()]/g, '');
  
  return ADMIN_PHONE_NUMBERS.some(admin => {
    const adminNormalized = admin.replace(/[\s\-()]/g, '');
    return normalized === adminNormalized || normalized.endsWith(adminNormalized.slice(-10));
  });
}

/**
 * Get the role for a user based on phone number
 */
export function getInitialUserRole(phoneNumber: string): 'admin' | 'user' {
  return isAdminPhoneNumber(phoneNumber) ? 'admin' : 'user';
}

/**
 * Log admin assignments (for debugging)
 */
export function logAdminAssignment(phoneNumber: string, role: 'admin' | 'user'): void {
  if (role === 'admin') {
    console.log(`✅ Admin role assigned to ${phoneNumber}`);
  }
}
